export const base_url = "https://api.qentrainsolutions.com/api/"; 
const customerData = localStorage.getItem("customer");
const storedUser = customerData ? JSON.parse(customerData) : null;

 const token = storedUser?.token || storedUser?.user?.token;

export const config = {
  headers: {
    Authorization: `Bearer ${token ? token : ""}`,
    Accept: "application/json",
  },
};

